import * as constants from './constants';

export function setMarket(payload) {
  return {
    type: constants.SET_MARKET,
    payload
  };
}

export function setReviewMarket(payload) {
  return {
    type: constants.SET_REVIEW_MARKET,
    payload
  };
}

export function setUserIsGlobal() {
  return {
    type: constants.SET_USER_IS_GLOBAL
  };
}

export function setUserIsServiceOffice() {
  return {
    type: constants.SET_USER_IS_SERVICE_OFFICE
  };
}

export function appStart(payload) {
  return {
    type: constants.APP_START,
    payload
  };
}

export function setLanguage(payload) {
  return {
    type: constants.SET_LANGUAGE,
    payload
  };
}

export function setReviewMarketLanguage(payload) {
  return {
    type: constants.SET_REVIEW_MARKET_LANGUAGE,
    payload
  };
}

export function setSaveAndCallback(payload) {
  return {
    type: constants.SAVE_AND_CALLBACK,
    payload
  };
}

export function setDataDirty() {
  return {
    type: constants.SET_DATA_DIRTY
  };
}

export function setDataNotDirty() {
  return {
    type: constants.SET_DATA_NOT_DIRTY
  };
}

export function getConfigs() {
  return {
    type: constants.GET_CONFIGS
  };
}

export function getConfigsDone(configs) {
  return {
    type: constants.GET_CONFIGS_DONE,
    payload: configs
  };
}

export function getConfigsFailed(error) {
  return {
    type: constants.GET_CONFIGS_FAILED,
    payload: error
  };
}

export function getGlobalConfigs() {
  return {
    type: constants.GET_GLOBAL_CONFIGS
  };
}

export function getGlobalConfigsDone(configs) {
  return {
    type: constants.GET_GLOBAL_CONFIGS_DONE,
    payload: configs
  };
}

export function getGlobalConfigsFailed(error) {
  return {
    type: constants.GET_GLOBAL_CONFIGS_FAILED,
    payload: error
  };
}

// get market config for Global approval flow

export function getMarketConfigs(market) {
  return {
    type: constants.GET_MARKET_CONFIGS,
    payload: market
  };
}

export function getMarketConfigsDone(configs) {
  return {
    type: constants.GET_MARKET_CONFIGS_DONE,
    payload: configs
  };
}

export function getMarketConfigsFailed(error) {
  return {
    type: constants.GET_MARKET_CONFIGS_FAILED,
    payload: error
  };
}

export function viewVisited(view) {
  return {
    type: constants.VIEW_VISITED,
    payload: view
  };
}

export function getMarketName() {
  return {
    type: constants.GET_MARKET_NAME
  };
}

export function getMarketNameDone(data) {
  return {
    type: constants.GET_MARKET_NAME_DONE,
    payload: data
  };
}

export function getMarketNameFailed(error) {
  return {
    type: constants.GET_MARKET_NAME_FAILED,
    payload: error
  };
}

export function fetchConfigsSeprately() {
  return {
    type: constants.FETCH_CONFIG_SEPRATELY
  };
}
